import React, { useEffect, useState, Suspense } from "react";
import Header from "./BaseComponents/Header";
import FotterMain from "./BaseComponents/FotterMain";
import CategoryDisplayCel from "./BaseComponents/HomeCels/CategoryDisplayCel";
import SectionTitle from "./BaseComponents/SectionTitle";
import {
  getCategoryList,
  getOEMCategoryList,
  hondaLogo,
  hiLogo,
  hiValuePlusLogo,
  GetHiValuePlusHomePageData,
} from "../networkCalls";
import { Modal } from "react-bootstrap";
import CloseIcon from "@mui/icons-material/Close";
import AboutUSCel from "./BaseComponents/HomeCels/AboutUSCel";
import EnqueyCel from "./BaseComponents/HomeCels/EnqueyCel";
import ExploreMore from "./BaseComponents/HomeCels/ExploreMore";
import FindDealerCel from "./BaseComponents/HomeCels/FindDealerCel";
import MainSlider from "./BaseComponents/HomeCels/MainSlider";
import WhyChoseUsCel from "./BaseComponents/HomeCels/WhyChoseUsCel";
import LoadingCellFullPage from "./LoadingCell/LoadingCellFullPage";
import { Link } from "react-router-dom";
import { useCookies } from "react-cookie";
import { Helmet } from "react-helmet";
import SEO from "./BaseComponents/SEO";
import OEMCategoryDisplayCel from "./BaseComponents/HomeCels/OEMCategoryDispalyCel";
import { Accordion, AccordionSummary, Typography } from "@mui/material";
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Button from '@mui/material/Button';

import AccordionActions from '@mui/material/AccordionActions';
import NewArrivalsCel from "./BaseComponents/HomeCels/NewArrivalsCel";
import HiValueCategoryDisplayCel from "./HIValuePlus/BaseComponents/CategoryProductDisplayCel";
// const MainSlider = React.lazy(() => import("./BaseComponents/HomeCels/MainSlider"));
// const AboutUSCel = React.lazy(() => import("./BaseComponents/HomeCels/AboutUSCel.js"));
// const WhyChoseUsCel = React.lazy(() => import("./BaseComponents/HomeCels/WhyChoseUsCel.js"));
// const EnqueyCel = React.lazy(() => import("./BaseComponents/HomeCels/EnqueyCel.js"));
// const FindDealerCel = React.lazy(() => import("./BaseComponents/HomeCels/FindDealerCel.js"));
// const ExploreMore = React.lazy(() => import("./BaseComponents/HomeCels/ExploreMore.js"));

const promise = getCategoryList();
const promise3 = getOEMCategoryList();
const promise2 = GetHiValuePlusHomePageData();

const Home = () => {
  const [cookie] = useCookies(["hondaCookiee"]);
  const [catlist, setCatlist] = useState([]);
  const [oemlist, setoemList] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const [show, setShow] = useState(true);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [categoryList, setcategoryList] = useState([]);

  useEffect(() => {
    promise.then((data) => {
      setCatlist(data?.CategoryListArray);
      setLoading(false);
    });
    promise2.then((res) => {
      console.log("response home page", res?.data?.bannersList);
      // setBannerData(res?.data?.bannersList);
      setcategoryList(res?.data?.categoryList);
      // setImpressionList(res?.data?.ImpressionList);

      // setCatlist(data?.CategoryListArray);
      setLoading(false);
    });
    promise3.then((data) => {
      console.log("data setCatlistOEM", data);
      setoemList(data?.OEMCategoryListArray);
    });
    if (cookie?.hondaCookiee) {
      setShow(false);
    }
  }, [catlist]);

  return (
    <>
      <SEO
        title="Generators|Tillers|Water Pumps|Brush Cutters|Lawn Mowers|General Purpose Engines|Outboard Motors"
        description="HIPP India's No. 1 power product company, is a subsidiary of Honda Motor Co. Japan. We have a wide & reliable product range of Portable Gensets, Water Pumps, Tiller, Brush Cutters, Lawnmowers & Outboard Motors."
        name="HIPP - Honda India Power"
        url="https://www.hondaindiapower.com/"
        type="Website"
      />
      <Header />
      <Suspense fallback={<div></div>}>
        <MainSlider />
      </Suspense>
      <div className="mt-3"></div>
      <div className="container">
        <div className="row">
          <div className="col-12">
            {" "}
            <marquee
              scrollamount="5"
              onmouseover="this.stop();"
              onmouseout="this.start();"
            >
              <p>
                It has come to our notice that some retailers are claiming to
                sell Honda Brand of Power Products on various online
                platforms/portals in India. We wish to inform all our valued
                customers that Honda India Power Products Ltd.(Formerly Honda
                Siel Power Products Ltd.) is selling its products through its
                online platform https://www.hondaindiapower.com in India &
                through its PAN India network of Authorized channel partners. To
                locate your nearest authorized Honda dealer, kindly follow this
                link{" "}
                <Link
                  to="https://www.hondaindiapower.com/service-network"
                  className="text-black"
                >
                  {" "}
                  https://www.hondaindiapower.com/service-network.
                </Link>
              </p>
            </marquee>
          </div>
        </div>
      </div>
      <div className="mt-2"></div>
      <SectionTitle logo={hondaLogo} />
      {catlist && catlist?.length > 0 ? (
        <>
          <CategoryDisplayCel catlist={catlist} />
        </>
      ) : null}
      <div className="my-4"></div>
      <SectionTitle logo={hiLogo} />
      {oemlist && oemlist?.length > 0 ? (
        <>
          <OEMCategoryDisplayCel catlist={oemlist} />
        </>
      ) : null}
      <div className="mt-5"></div>
      <div className="container">
        <div className="d-flex align-items-center mb-3">
          <div className="text-capitalize me-2">
            <h4 className="d-flex align-items-center m-0 hivaluepluscategoryrangeheading">
              <img src={hiValuePlusLogo} className="headinglogoimg" />
              <span className="txtgray">Refurbished Category Range</span>{" "}
            </h4>
          </div>
          <div className="flex-grow-1 position-relative bg-border-mid"></div>
        </div>
        {categoryList && categoryList?.length > 0 ? (
          <div className="mt60">
            <HiValueCategoryDisplayCel
              categoryList={categoryList}
            />
          </div>
        ) : null}
      </div>

      <div className="mt-5"></div>
      <div className="bg-white">
        <div className="container">
          <div className="row">
            <div className="col-md-6 col-12 mt-2 mb-2">
              <Suspense fallback={<div></div>}>
                <EnqueyCel catlist={catlist} />
              </Suspense>
            </div>
            <div className="col-md-6 col-12 mt-2 mb-2">
              <Suspense fallback={<div></div>}>
                <FindDealerCel catlist={catlist} />
              </Suspense>
            </div>
          </div>
        </div>
      </div>
      <div className="mt-5"></div>
      <Suspense fallback={<div></div>}>
        <div className="bgsgray">

          <ExploreMore />
        </div>
      </Suspense>
      {/* <div className="mt-5"></div> */}
      <Suspense fallback={<div></div>}>
        <NewArrivalsCel />
      </Suspense>

      <div className="mt-5"></div>
      <Suspense fallback={<div></div>}>
        <AboutUSCel />
      </Suspense>
      {/* <AboutUSCel /> */}


      <div className="mt-5"></div>
      <Suspense fallback={<div></div>}>
        <WhyChoseUsCel />
      </Suspense>

      <Modal
        size="lg"
        show={show}
        backdrop="static"
        keyboard={false}
        contentClassName="border-0 rounded-0"
        onHide={() => handleClose()}
        aria-labelledby="video-lg"
      >
        <Modal.Body className="p-0">
          <div
            onClick={() => handleClose()}
            aria-label="delete"
            size="small"
            className="position-absolute top-0 end-0 btn-out"
          >
            <CloseIcon fontSize="small" className="text-white" />
          </div>
          <div className="p-4">
            <div className="row">
              <div className="col-12">
                <h4 className="d-inline-block m-0 fw-bold text-uppercase">
                  <span className="txtred">BEWARE</span>{" "}
                  <span className="txtdgray">OF COUNTERFEITS</span>
                </h4>
              </div>
              <div className="col-12">
                <div className="mt-3">
                  <p>
                    <strong>Honda India Power Products Ltd.(HIPP) </strong>{" "}
                    (Formerly known as Honda Siel Power Products Ltd.) is a
                    leader in the Power Products industry for over 3 decades
                    engaged in the Manufacturing and Marketing of Portable
                    Generators, Water Pumps, Tillers &amp; General Purpose
                    Engines in India and abroad. We are also into the Marketing
                    of Lawn Mowers, Brush Cutter &amp; Long tailed boat engines.{" "}
                  </p>
                  <p>
                    All these products are marketed under the brand <b>HONDA</b>
                  </p>
                  <p>
                    We have come across instances of some unscrupulous parties
                    selling COUNTERFEIT <b>HONDA Power Products</b>. We are
                    alerting our valued customers, retailers and distributors
                    about this issue and simultaneously working to resolve it.
                  </p>
                  <p>
                    Kindly note that in the event of your having purchased a
                    fake HIPP product, HIPP will NOT be able to honor the
                    product warranty nor be responsible for the performance of
                    such counterfeit products.{" "}
                  </p>
                  <p>
                    We recommend that our valued customers exercise caution
                    while buying the aforementioned products.
                  </p>
                  <h5>HOW TO AVOID BUYING COUNTERFEITS</h5>
                  <ul>
                    <li>
                      Purchase HIPP products directly from an authorized HIPP
                      outlet, listed on our website: - www.hondaindiapower.com
                    </li>
                    <li>
                      Check the Trust-O-Gram (A 3D Sticker with Honda Logo and
                      Secure written on it) pasted on the Product which
                      qualifies it as GENUINE HONDA.
                    </li>
                    <li>
                      Call our Customer Care{" "}
                      <strong>Toll Free no. 1800-11-2323</strong> to check if
                      the outlet is authorized or not.
                    </li>
                  </ul>
                  <p>
                    For any clarification, please write to us at{" "}
                    <a href="mailto:customer.support@hipp.co.in">
                      customer.support@hipp.co.in
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <FotterMain />
    </>
  );
};
export default Home;
